module.exports = __webpack_public_path__ + "static/kimberly-hardaway-social-f95a06c3a872446ed24899df7787b927.jpg";